export default "__VITE_ASSET__2MVJUSUV__"